
import type { LocationQuery } from 'vue-router';

import { getIntegerOrUndefined } from '@/util/numbers/getIntegerOrDefault';

export interface PaginationParams {
  page?: number;
  first?: number;
}

const defaultParamsValues: Required<PaginationParams> = {
  page: 1,
  first: 20,
};

export function getPaginationFromQuery(query: LocationQuery, defaultValues = defaultParamsValues): PaginationParams {
  const { page, first } = query;
  return {
    page: getIntegerOrUndefined(page, defaultValues.page),
    first: getIntegerOrUndefined(first, defaultValues.first),
  };
}

export const getPaginationToQuery = (
  params: PaginationParams,
  defaultValues = defaultParamsValues,
): PaginationParams => {
  const values: PaginationParams = {};
  if (params.first && params.first > 0 && params.first !== defaultValues.first) {
    values.first = params.first;
  }
  if (params.page && params.page > defaultValues.page) {
    values.page = params.page;
  }
  return values;
};
